export default __webpack_public_path__ + "static/media/garbage-can.beb2b3c3.svg";